import { Form, Select } from "antd";
import { phoneNumbersSelector } from "appredux/selectors";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo } from "react";
import { Text } from "components/UI";

const PhoneNumberSelector = (props) => {
  const { t } = useTranslation();
  const phoneNumbers = useSelector(phoneNumbersSelector);

  const formattedOptions = useMemo(() => {
    return phoneNumbers.map((row) => {
      return {
        ...row,
        value: row.id,
        label: `${row.name} - ${row.phone_number}`,
      };
    });
  }, [phoneNumbers]);

  const optionRender = useCallback((option) => {
    return (
      <div className="flex flex-row items-center justify-between">
        <Text ellipsis>{option.data.name}</Text>
        <Text type="secondary">{option.data.phone_number}</Text>
      </div>
    );
  }, []);

  return (
    <Form.Item label={t("phone_number")} name="phone_number_id" {...props}>
      <Select
        placeholder={t("select_phone_number")}
        options={formattedOptions}
        allowClear
        filterOption
        optionFilterProp="label"
        showSearch
        // fieldNames={{ label: "name", value: "id" }}
        optionRender={optionRender}
        optionLabelProp="label"
      />
    </Form.Item>
  );
};

export default PhoneNumberSelector;
